import React from 'react';
import PropTypes from 'prop-types';

export const bonusBetFlag = (<span
  aria-label="Bet using free bet"
  style={{ paddingTop: '1px', marginLeft: '4px' }}
>
  <img
    height="16px"
    alt="Bet using free bet"
    src="/assets/images/thirdPartyBet/icon-promos.svg"
    role="presentation"
  />
</span>);

export const thirdPartyFlag = (<span
  aria-label="Bet using third party"
  style={{ paddingTop: '1px', marginLeft: '4px' }}
>
  <img
    height="16px"
    alt="Bet using third party"
    src="/assets/images/thirdPartyBet/icon-3rdPartyBet.svg"
    role="presentation"
  />
</span>);

export const rule4DeductionFlag = (<span
  aria-label="Bet includes a Rule 4 deduction"
  style={{ paddingTop: '1px', marginLeft: '4px' }}
>
  <img
    height="16px"
    alt="Bet includes a Rule 4 deduction"
    src="/assets/images/thirdPartyBet/icon-R4Bet.svg"
    role="presentation"
  />
</span>);

export const MatchbookZeroFlag = (<span
  aria-label="Bet was placed on Matchbook Zero"
  style={{ paddingTop: '1px', marginLeft: '4px' }}
>
  <img
    height="16px"
    width="16px"
    alt="Bet was placed on Matchbook Zero"
    src="/assets/images/thirdPartyBet/zero.svg"
    role="presentation"
  />
</span>);

export const InPlayFlag = ({ type }) => {
  let message = 'Bet was matched while event was live.';
  if (type === 'offers') {
    message = 'Bet was placed (Unmatched) while event was live.';
  }
  return (
    <span
      aria-label={message}
      className="hint hint--top"
    >
      <img
        height="16px"
        alt="Bet was placed in-play"
        src="/assets/images/thirdPartyBet/icon-livebetting.svg"
        role="presentation"
      />
    </span>
  );
};

InPlayFlag.propTypes = {
  type: PropTypes.string.isRequired
};
